




















































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import baseService from "@/service/baseService";
import { IndexBar, IndexAnchor, Cell, Search, Tab, Tabs } from "vant";
import * as _ from "lodash";
import dataShare from "@/views/mall/dataShare";
import { iteratee } from "lodash";
import enumUtils from "@/utils/enumUtils";
import { ApplyArea, categoryMap, Categorys } from "@/model/Base";

@Component({
  name: "selectCity",
  components: {
    [IndexBar.name]: IndexBar,
    [IndexAnchor.name]: IndexAnchor,
    [Cell.name]: Cell,
    [Search.name]: Search,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
  },
})
export default class extends Vue {
  //data
  searchCity: string = "";
  ZoneDatas: object[] = [];
  get ZoneLists() {
    return this.currentCache.Sorts;
  }
  get indexList() {
    return this.currentCache.Sorts.map((o: any) => o.title);
  }
  get currentCache() {
    return this.applyArea == ApplyArea.Internal ? this.cacheData.Internal : this.cacheData.Overseas;
  }

  isSupportOverseas = false;

  dataShare = dataShare;

  get isShowSearchPage() {
    return this.searchCity && this.searchCity != "";
  }
  applyArea = 1126;

  searchLists: object[] = [];
  get areas() {
    let areas = enumUtils.makeArray(Categorys.ApplyArea);
    _.forEach(areas, item => {
      if (item.value == 1126) {
        item.text = this.$root.$t("modules_selectcity_guonei");
      }
      if (item.value == 1127) {
        item.text = this.$root.$t("modules_selectcity_guoji");
      }
    });
    return areas;
  }

  get ServiceType() {
    return this.$route.query.ServiceType;
  }

  mounted() {
    this.getCityData();
  }

  getCityData(value?: string, searchData?: any) {
    const data: any = {
      ZoneType: "1444",
      ZoneTypes: "",
      ZoneName: "",
      CountryID: 151,
      Props: "CountryID,CityCode,CityName,CitySpell,OrderBy,ZoneID",
      PageSize: 10000,
    };
    // 车站
    if (this.ServiceType == "TrainService") {
      data.ZoneType = "1807";
      data.CountryID= '';
      data.Props = "CountryID,ZoneCode,ZoneName,ZoneSpell,OrderBy,ZoneType";
      //机场
    } else if (this.ServiceType == "FlightService") {
      this.isSupportOverseas = true;
      (data as any).CountryID = null;

      data.ZoneType = "1447";
      data.Props = "CountryID,CityCode,CityName,CitySpell,OrderBy";
    } else if (this.ServiceType == "HotelService") {
      data.Props = "CountryID,CityCode,CityID,CityName,CitySpell,OrderBy,ZoneID,ZoneName,ZoneType";
    }
    if (value && searchData) {
      data.ZoneType = searchData.ZoneType;
      data.ZoneTypes = searchData.ZoneTypes;
      data.Props = searchData.Props;
      data.ZoneName = searchData.ZoneName;
      data.PageSize = searchData.PageSize;
      data.Props = searchData.Props;
    }
    baseService.getZoneList(data).then(res => {
      if (!res.isSucc || !res.result || !res.result.entities) {
        return;
      }
      const results = res.result.entities;
      _.forEach(results, o => {
        let zoneType = categoryMap[o.ZoneType];
        o.type = (zoneType && zoneType.CategoryTitle) || "";
      });
      if (this.ServiceType == "TrainService") {
        const trainDatas: object[] = [];
        _.forEach(results, item => {
          if (!item.ZoneCode) return;
          const list = {
            value: item.ZoneCode,
            label: item.ZoneName,
            type: item.type,
            CitySpell: item.ZoneSpell,
            OrderBy: item.OrderBy || 999999,
            CountryID: item.CountryID,
            ZoneType: item.ZoneType,
          };
          trainDatas.push(list);
        });
        this.ZoneDatas = _.sortBy(trainDatas, (item: any) => item.OrderBy);
      } else if (this.ServiceType == "TrafficService") {
        _.forEach(results, item => {
          if (!item.CitySpell) {
            item.CitySpell = item.CityCode;
          }
          const list: object = {
            value: item.CityCode,
            label: item.CityName,
            type: item.type,
            CitySpell: item.CitySpell,
            OrderBy: item.OrderBy,
            CountryID: item.CountryID,
            ZoneID: item.ZoneID,
          };
          this.ZoneDatas.push(list);
        });
      } else {
        _.forEach(results, item => {
          if (item.CityCode) {
            if (!item.CitySpell) {
              item.CitySpell = item.CityCode;
            }
            const list: object = {
              value: item.CityCode,
              label: item.CityName,
              type: item.type,
              CitySpell: item.CitySpell,
              OrderBy: item.OrderBy,
              CountryID: item.CountryID,
              ZoneID: item.ZoneID,
            };
            this.ZoneDatas.push(list);
          }
        });
      }
      if (value && searchData) {
        this.searchLists = results;
        return;
      }

      let InternalHots: any[] = [];
      let InternalCitys: any[] = [];

      let OverseasHots: any[] = [];
      let OverseasCitys: any[] = [];
      _.forEach(this.ZoneDatas, (item: any) => {
        if (item.label == "") {
          return;
        }
        // if (item.ZoneType == (this.$root.$t("modules_selectcity_chezhan") as string)) {
        if (this.ServiceType == 'TrainService') {
          // if ([151, 139, 134, 106].indexOf(item.CountryID) >= 0) {
            if (item.OrderBy) {
              InternalHots.push(item);
            }
            InternalCitys.push(item);
          // }
        } else if (item.CountryID == 151) {
          if (item.OrderBy) {
            InternalHots.push(item);
          }
          InternalCitys.push(item);
        } else if (item.CountryID != 151) {
          if (item.OrderBy) {
            OverseasHots.push(item);
          }
          OverseasCitys.push(item);
        }
      });
      this.cacheData.Internal.Hots = InternalHots as any;
      this.cacheData.Internal.Citys = InternalCitys as any;
      this.cacheData.Overseas.Hots = OverseasHots as any;
      this.cacheData.Overseas.Citys = OverseasCitys as any;

      this.handleZoneDatas(this.cacheData.Internal);
      this.handleZoneDatas(this.cacheData.Overseas);
    });
  }
  cacheData = {
    Internal: {
      Hots: [],
      Citys: [],
      Sorts: [],
    },
    Overseas: {
      Hots: [],
      Citys: [],
      Sorts: [],
    },
  };
  //对所有城市数据做处理
  handleZoneDatas(cacheCitys: any) {
    const allCityDatas: object[] = cacheCitys.Citys;
    let hotCitys: any[] = cacheCitys.Hots;
    let hotCity = { title: this.$root.$t("modules_selectcity_remen") as string, cities: hotCitys };

    hotCity.cities = _.orderBy(hotCitys, o => o.OrderBy, "asc");

    //按照A-Z分类
    const cityIndexList = _.groupBy(allCityDatas, (item: any) => _.upperFirst(item.CitySpell).slice(0, 1));
    const citySortList = this.getKeys(cityIndexList);
    citySortList.sort((a: any, b: any) => a.title.charCodeAt(0) - b.title.charCodeAt(0));
    let cityList = _.concat([hotCity], citySortList);
    cacheCitys.Sorts = cityList as any;
  }

  //按照key排序
  getKeys(value: any) {
    const lists: object[] = [];
    for (const key in value) {
      if (value.hasOwnProperty(key)) {
        lists.push({ title: key, cities: value[key] });
      }
    }
    return lists;
  }
  chooseCity(city: any) {
    this.currentCache.Sorts = [];
    city.originID = city.ZoneID;
    city.originName = city.ZoneName;
    (this as any).dataShare.City = city;
    this.back();
    console.log(city);
    
    
    
    
  }

  cancel() {
    this.searchCity = "";
  }

  back() {
    this.currentCache.Sorts = [];
    history.back();
  }

  @Watch("searchCity", { deep: true })
  handleWatch(newVal: string, oldVal: string) {
    if (newVal == "") {
      return;
    }
    if (this.ServiceType == "HotelService") {
      const data = {
        PageSize: 10,
        ZoneTypes: "1444,1447,1449,1807,1809",
        ZoneName: newVal,
        CityID: "",
      };
      this.getCityData(newVal, data);
      return;
    }
    let searchLists = this.currentCache.Citys.filter(
      (el: any) => (el.label && el.label.indexOf(newVal) >= 0) || (el.value && el.value.indexOf(newVal) >= 0) || (el.CitySpell && el.CitySpell.indexOf(newVal) >= 0)
    );
    this.searchLists = _.uniq(searchLists);
  }
}
